import React from 'react';
import { Editor, Transforms, Element as SlateElement } from 'slate';
import { Plugin, CustomEditor, CustomElement } from '../types';

const ListPlugin: Plugin = {
  name: 'list',
  
  commands: {
    toggleBulletedList: (editor: CustomEditor) => {
      const { selection } = editor;
      if (!selection) return;
      
      const [match] = Array.from(
        Editor.nodes(editor, {
          at: Editor.unhangRange(editor, selection),
          match: (n) =>
            !Editor.isEditor(n) && SlateElement.isElement(n) && (n as any).type === 'bulleted-list',
        })
      );

      const isActive = !!match;
      
      Transforms.setNodes<CustomElement>(
        editor,
        { type: isActive ? 'paragraph' : 'bulleted-list' as any },
        { at: Editor.unhangRange(editor, selection) }
      );
    },
    
    toggleNumberedList: (editor: CustomEditor) => {
      const { selection } = editor;
      if (!selection) return;
      
      const [match] = Array.from(
        Editor.nodes(editor, {
          at: Editor.unhangRange(editor, selection),
          match: (n) =>
            !Editor.isEditor(n) && SlateElement.isElement(n) && (n as any).type === 'numbered-list',
        })
      );

      const isActive = !!match;
      
      Transforms.setNodes<CustomElement>(
        editor,
        { type: isActive ? 'paragraph' : 'numbered-list' as any },
        { at: Editor.unhangRange(editor, selection) }
      );
    }
  }
};

export default ListPlugin; 